import {
  ADD_PHYSICAL_ART,
  ADD_PHYSICAL_ART_SUCCESS,
  ADD_PHYSICAL_ART_FAIL,
  GET_PHYSICAL_ART_BY_USER_ID,
  GET_PHYSICAL_ART_BY_USER_ID_SUCCESS,
  GET_PHYSICAL_ART_BY_USER_ID_FAIL,
  GET_PHYSICAL_ART_BY_ID,
  GET_PHYSICAL_ART_BY_ID_SUCCESS,
  GET_PHYSICAL_ART_BY_ID_FAIL,
  GET_PHYSICAL_ART_BY_SELL_ITEM_ID,
  GET_PHYSICAL_ART_BY_SELL_ITEM_ID_SUCCESS,
  GET_PHYSICAL_ART_BY_SELL_ITEM_ID_FAIL,
  ADD_PHYSICAL_SELLITEM,
  ADD_PHYSICAL_SELLITEM_SUCCESS,
  ADD_PHYSICAL_SELLITEM_FAIL,
  GET_EXPLORE_PHYSICAL_ART,
  GET_EXPLORE_PHYSICAL_ART_SUCCESS,
  GET_EXPLORE_PHYSICAL_ART_FAIL,
  LIKE_VIEW_PHYSICAL,
  LIKE_VIEW_PHYSICAL_SUCCESS,
  LIKE_VIEW_PHYSICAL_FAIL,
  P_GET_CANVAS_PAPER_SIZE,
  P_GET_CANVAS_PAPER_SIZE_SUCCESS,
  P_GET_CANVAS_PAPER_SIZE_FAIL,
} from "./actionTypes";

// ========================= PHYSICAL ART METADATA =========================

export const addPhysicalArt = (data, callback) => ({
  type: ADD_PHYSICAL_ART,
  payload: { data, callback },
});
export const addPhysicalArtSuccess = (data) => ({
  type: ADD_PHYSICAL_ART_SUCCESS,
  payload: data,
});
export const addPhysicalArtFail = (error) => ({
  type: ADD_PHYSICAL_ART_FAIL,
  payload: error,
});

export const getPhysicalArtById = (id, callback) => ({
  type: GET_PHYSICAL_ART_BY_ID,
  payload: { id, callback },
});
export const getPhysicalArtByIdSuccess = (data) => ({
  type: GET_PHYSICAL_ART_BY_ID_SUCCESS,
  payload: data,
});
export const getPhysicalArtByIdFail = (error) => ({
  type: GET_PHYSICAL_ART_BY_ID_FAIL,
  payload: error,
});

export const getPhysicalArtByUserId = (id, callback) => ({
  type: GET_PHYSICAL_ART_BY_USER_ID,
  payload: { id, callback },
});
export const getPhysicalArtByUserIdSuccess = (data) => ({
  type: GET_PHYSICAL_ART_BY_USER_ID_SUCCESS,
  payload: data,
});
export const getPhysicalArtByUserIdFail = (error) => ({
  type: GET_PHYSICAL_ART_BY_USER_ID_FAIL,
  payload: error,
});

export const getPhysicalArtBySellItemId = (sell_item_id, callback) => ({
  type: GET_PHYSICAL_ART_BY_SELL_ITEM_ID,
  payload: { sell_item_id, callback },
});
export const getPhysicalArtBySellItemIdSuccess = (data) => ({
  type: GET_PHYSICAL_ART_BY_SELL_ITEM_ID_SUCCESS,
  payload: data,
});
export const getPhysicalArtBySellItemIdFail = (error) => ({
  type: GET_PHYSICAL_ART_BY_SELL_ITEM_ID_FAIL,
  payload: error,
});

// ========================= PHYSICAL ART SELL ITEMS =========================

export const addPhysicalSellItem = (data, callback) => ({
  type: ADD_PHYSICAL_SELLITEM,
  payload: { data, callback },
});
export const addPhysicalSellItemSuccess = (data) => ({
  type: ADD_PHYSICAL_SELLITEM_SUCCESS,
  payload: data,
});
export const addPhysicalSellItemFail = (error) => ({
  type: ADD_PHYSICAL_SELLITEM_FAIL,
  payload: error,
});

export const getExplorePhysicalArt = (payload) => ({
  type: GET_EXPLORE_PHYSICAL_ART,
  payload,
});
export const getExplorePhysicalArtSuccess = (data) => ({
  type: GET_EXPLORE_PHYSICAL_ART_SUCCESS,
  payload: data,
});
export const getExplorePhysicalArtFail = (error) => ({
  type: GET_EXPLORE_PHYSICAL_ART_FAIL,
  payload: error,
});

export const likeViewPhysical = (data, callback) => ({
  type: LIKE_VIEW_PHYSICAL,
  payload: { data, callback },
});
export const likeViewPhysicalSuccess = (data) => ({
  type: LIKE_VIEW_PHYSICAL_SUCCESS,
  payload: data,
});
export const likeViewPhysicalFail = (error) => ({
  type: LIKE_VIEW_PHYSICAL_FAIL,
  payload: error,
});



// add action for fetch size for printer 


export const PhysicalgetCanvasPaperSize = (data, callback) => ({
  type: P_GET_CANVAS_PAPER_SIZE,
  payload: { data, callback },
});
export const PhysicalgetCanvasPaperSizeSuccess = (data) => ({
  type: P_GET_CANVAS_PAPER_SIZE_SUCCESS,
  payload: data,
});
export const PhysicalgetCanvasPaperSizeFail = (error) => ({
  type: P_GET_CANVAS_PAPER_SIZE_FAIL,
  payload: error,
});
